import update from "immutability-helper";
import {LoginActions} from "../actions/Login";

export const initialState = () => {
  return {
    codeRequested: false,
    open: false,
    success: false,
    errors: {}, //  phone: 'Invalid phone number'
  }
}

const login = (state = initialState(), action) => {
  switch (action.type) {
    case LoginActions.SET_ATTRIBUTE:
      return update(state, { [action.key]: { $set: action.value } });
    case LoginActions.RESET_STATE:
      return update(state, {$set: initialState() })
    case LoginActions.ADD_ERROR:
      return update(state, { errors: { [action.key] : { $set: action.value } } });
    default:
      return state;
  }
};

export default login;
